<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2023-10-11 14:46:57
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-30 11:16:23
 * @FilePath: /seller.sviptrader.com/src/views/configure/rulesManage/list/components/talentClue/components/distribute.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="distribute-wrapper" v-loading="loading">
		<ExpectEmpty v-if="showExpectedEmpty"></ExpectEmpty>
		<template v-else>
			<Tip class="fz-12" v-if="list.length > 0" content="规则说明:同时存在多个已启用的规则，则满足其一即可"></Tip>
			<platform-tab @change="handlePlatformChange" :platformId="platformId"></platform-tab>
			<ExpectEmpty v-if="$isSp()"></ExpectEmpty>
			<template v-else-if="canShowPlatformList.filter(item => item.value == platformId).length > 0">
				<div class="filter-wrappper flex-row-center-between">
					<el-button type="primary" @click="gotoSet"
						v-auth="['configure:rules:talentClue:filterRule:add']">新建规则</el-button>
					<span class="mr-24 font-h6-regular yx-color-text-regular yx-pingfang platClass">
						状态
						<el-select size="mini" v-model="selectStatus" @change="selectConditionList">
							<el-option v-for="item in statusSearchList" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</span>
				</div>
				<div class="list-content" v-if="list.length > 0">
					<InfoCard class="mt-16" v-for="item in list" :key="item.id">
						<div slot="title" class="flex-row-center-between">
							<div class="flex-row-align-center">
								<rd-text class="yx-pingfang-semibold" :bigger="true" v-if="filterTypeMap[platformId][item.selectType]">
									{{ filterTypeMap[platformId][item.selectType].desc }}
								</rd-text>
								<span class="get-numbers font-h6-medium ml-12">
									累计已获取
									<span class="yx-color-success">{{ item.collectNum }}</span>
									条
									<!-- 条，今日获取联系方式
								<span class="yx-color-success">{{ item.collectNumToday }}</span>
								条
								<explain size="12" content="切换数据视角仅影响页面展示数据范围" /> -->
								</span>
							</div>
							<div>
								<i :class="ruleStatusMap[item.status].class"></i>
								<span class="font-h6-regular yx-color-text-regular">{{ ruleStatusMap[item.status].desc }}</span>
							</div>
						</div>
						<div slot="content" class="flex-row-center-between">
							<div class="left">
								<div class="flex-row">
									<span class="label yx-color-text-secondary font-h6-regular">筛选条件：</span>
									<rd-text :ellipsisRow="2" class="yx-color-text-regular">{{ item.selectConditionShow }}</rd-text>
								</div>
								<div class="mt-8 fz-12 yx-color-text-regular flex-row-align-center">
									<span class="label yx-color-text-secondary">更新时间：</span>
									<span class="yx-color-text-regular">{{ item.lastTime }}</span>
									<span class="label ml-24 yx-color-text-secondary">更新人：</span>
									<span class="yx-color-text-regular">{{ item.operateName }}</span>
								</div>
							</div>
							<div class="right flex-row-center-between" style="margin-left: 73px">
								<el-button size="mini" @click="handleEdit(item)"
									v-auth="['configure:rules:talentClue:filterRule:mdf']">修改</el-button>
								<el-button v-if="item.status === RULE_STOP" v-auth="['configure:rules:talentClue:filterRule:del']"
									size="mini" @click="deleteItem(item)">
									移除
								</el-button>
								<el-button size="mini" v-auth="['configure:rules:talentClue:filterRule:open']"
									:type="item.status === RULE_STOP ? 'primary' : ''" @click="handleToggleStop(item)">
									{{ getBtnDesc(item) }}
								</el-button>
							</div>
						</div>
					</InfoCard>
				</div>
				<empty v-if="isEmpty" style="margin-top: 96px">
					<div slot="desc" class="yx-color-text-secondary font-h6-regular">
						<p class="font-h4-medium yx-color-text-primary">暂未创建条件</p>
						<p class="yx-color-text-secondary font-h6-regular">{{ getDesc() }}</p>
						<el-button type="primary" class="mt-16" @click="gotoSet"
							v-auth="['configure:rules:talentClue:filterRule:add']">去设置</el-button>
					</div>
				</empty>
			</template>

		</template>
	</div>
</template>

<script>
import { selectConditionList, selectConditionRemove, selectConditionStart, selectConditionStop } from '@/api/settings';
import { mapGetters } from 'vuex';
import ExpectEmpty from '@/components/ui/expectEmpty/index.vue';
import InfoCard from './infoCard.vue';
import { addUrlMap, statusSearchList, filterTypeMap, ruleStatusMap, RULE_STOP, modifyUrlMap } from '../const';

export default {
	data() {
		return {
			filterTypeMap,
			ruleStatusMap,
			platformId: '',
			RULE_STOP,
			selectStatus: 0,
			loading: false,
			statusSearchList,
			list: [],
			isEmpty: false, // 查询之后是否是空
		};
	},
	components: {
		InfoCard,
		ExpectEmpty,
	},
	created() {
		this.platformId = this.canShowPlatformList.filter(item => this.$isPlatOr(item.value, ['dy', 'ks']))[0]?.value;
		this.platformId && this.selectConditionList();
	},
	computed: {
		...mapGetters(['canShowPlatformList']),
		showExpectedEmpty({ canShowPlatformList }) {
			return canShowPlatformList.filter(item => this.$isPlatOr(item.value, ['dy', 'ks']))?.length == 0;
		},
	},
	methods: {
		getDesc() {
			let platMap = {
				[dataMap.PLATFORM_DY.value]: '请前往抖音精选联盟设置条件',
				// [dataMap.PLATFORM_XHS.value]: '请前往小红书达人广场设置条件',
				// [dataMap.PLATFORM_SP.value]: '请前往视频号达人广场设置条件',
				[dataMap.PLATFORM_KS.value]: '请前往快手达人广场设置条件',
			};
			return platMap[this.platformId];
		},
		handlePlatformChange(val) {
			this.platformId = val;
			this.selectConditionList();
		},
		getBtnDesc(item) {
			return item.status === RULE_STOP ? '启用' : '停用';
		},
		async handleToggleStop(item) {
			const btnText =
				item.status === RULE_STOP ? '同场景仅可存在1个启用状态的规则，确认要继续启用么？' : '停用规则将不参与自动获取达人任务，确认要停用么？';
			this.$modal({
				title: '提示',
				content: btnText,
				size: 'small',
				btns: [
					{
						type: 'default',
						text: '取消',
						key: 'cancel',
					},
					{
						type: 'primary',
						text: `确认${this.getBtnDesc(item)}`,
						key: 'confirm',
					},
				],
			})
				.then(res => {
					if (res.key == 'confirm') {
						this.toggleStop(item);
						res.done();
					} else {
						res.done();
					}
				})
				.catch(() => { });
		},
		async toggleStop(item) {
			const { status, id } = item;
			try {
				const api = status === RULE_STOP ? selectConditionStart : selectConditionStop;
				await api({
					id,
				});
				this.selectConditionList();
				this.$message.success(`${this.getBtnDesc(item)}成功`);
			} catch (error) { }
		},
		async selectConditionList() {
			try {
				this.loading = true;
				const { list } = await selectConditionList({
					platformId: this.platformId,
					selectStatus: this.selectStatus,
				});
				this.list = list;
				this.isEmpty = !list?.length;
			} catch (e) {
				this.isEmpty = true;
			} finally {
				this.loading = false;
			}
		},
		deleteItem(item) {
			this.$modal({
				title: '确认移除？',
				content: '确认要移除该规则么？',
				size: 'small',
				btns: [
					{
						type: 'default',
						text: '取消',
						key: 'cancel',
					},
					{
						type: 'primary',
						text: `确认移除`,
						key: 'confirm',
					},
				],
			})
				.then(res => {
					if (res.key == 'confirm') {
						this.selectConditionRemove(item.id);
						res.done();
					} else {
						res.done();
					}
				})
				.catch(() => { });
		},
		async selectConditionRemove(id) {
			await selectConditionRemove({
				id,
			});
			this.$message.success('移除成功');
			this.selectConditionList();
		},
		handleEdit({ selectType }) {
			window.open(modifyUrlMap[this.platformId][selectType], '_blank');
		},
		gotoSet() {
			window.open(addUrlMap[this.platformId], '_blank');
		},
	},
};
</script>

<style lang="less" scoped>
.red-icon,
.green-icon {
	display: inline-block;
	height: 6px;
	width: 6px;
	flex-shrink: 0;
	border-radius: 3px;
	margin-left: 8px;
	margin-right: 6px;
}

.red-icon {
	background: @color-error;
}

.green-icon {
	background: @color-g;
}

.red-icon {
	display: inline-block;
	height: 6px;
	width: 6px;
	flex-shrink: 0;
	border-radius: 3px;
	background: @color-error;
	margin-left: 8px;
	margin-right: 6px;
}

.content {
	.label {
		line-height: 20px;
		flex-shrink: 0;
	}
}

.get-numbers {
	height: 24px;
	line-height: 24px;
	padding: 0 8px;
	background-color: #fff;
	border-radius: 6px;
}
</style>
